document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded and parsed');

  // Verify if jQuery is loaded
  if (window.jQuery) {
    console.log('jQuery is loaded');
  } else {
    console.error('jQuery is NOT loaded');
  }

  // Get the customer data from Shopify Liquid
  const customerEmail = window.customerEmail;
  const customerId = window.customerId;
  const currentPoints = parseInt(window.currentPoints, 10);

  console.log("Customer data loaded:");
  console.log("Customer Email:", customerEmail);
  console.log("Customer ID:", customerId);
  console.log("Current Points:", currentPoints);

  // Function to handle redeem button click and trigger Firebase function
  const trackRedeemButtonClick = (discountValue, pointsToDeduct, messageElementId) => {
    console.log(`Attempting to redeem ${discountValue}% discount`);
    console.log('Sending AJAX request to Firebase function...');

    $.ajax({
      type: 'POST',
      url: 'https://senddiscountnotification-wdi67ghera-uc.a.run.app', // Updated function URL
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        email: customerEmail,
        discount: discountValue,
        customerId: customerId,
        currentPoints: currentPoints,
        pointsToDeduct: pointsToDeduct
      }),
      beforeSend: function(xhr) {
        console.log('Request URL:', this.url);
        console.log('Request Data:', this.data);
        xhr.setRequestHeader('Content-Type', 'application/json');
      },
      success: function(response) {
        console.log('AJAX request successful:', response);
        const messageElement = document.getElementById(messageElementId);
        if (messageElement) {
          messageElement.style.display = "block";
        }
        // Optional: Update points display or show success message
        alert(`Pomyślnie wykorzystano zniżkę ${discountValue}%!`);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Error sending email notification:', {
          status: jqXHR.status,
          responseText: jqXHR.responseText,
          textStatus: textStatus,
          errorThrown: errorThrown
        });
        alert('Wystąpił błąd podczas realizacji zniżki. Proszę spróbować ponownie później.');
      }
    });
  };

  // Attach event listeners to discount buttons (if they exist)
  const discount5Button = document.getElementById('discount-5');
  const discount8Button = document.getElementById('discount-8');
  const discount12Button = document.getElementById('discount-12');

  const pointsFor5Percent = 800;
  const pointsFor8Percent = 1400;
  const pointsFor12Percent = 2000;

  if (discount5Button) {
    console.log("5% discount button found. Attaching event listener...");
    discount5Button.addEventListener('click', () => trackRedeemButtonClick(5, pointsFor5Percent, 'message-5'));
  } else {
    console.log("5% discount button NOT found");
  }

  if (discount8Button) {
    console.log("8% discount button found. Attaching event listener...");
    discount8Button.addEventListener('click', () => trackRedeemButtonClick(8, pointsFor8Percent, 'message-8'));
  } else {
    console.log("8% discount button NOT found");
  }

  if (discount12Button) {
    console.log("12% discount button found. Attaching event listener...");
    discount12Button.addEventListener('click', () => trackRedeemButtonClick(12, pointsFor12Percent, 'message-12'));
  } else {
    console.log("12% discount button NOT found");
  }
});

